import store from '../store';

// CYCLE_STATUS_NONE = 0
// CYCLE_STATUS_CREATED = 1
// CYCLE_STATUS_STARTING = 2
// CYCLE_STATUS_AVAILABLE = 3
// CYCLE_STATUS_WAITING = 4
// CYCLE_STATUS_COMPLETED = 5
// CYCLE_STATUS_REMOVED = 6
export const getCycleStatusDesc = (status) => {
	switch (parseInt(status)) {
		case 0: return store.getState().global?.global_data?.statusDescriptions?.none;
		case 1:	return store.getState().global?.global_data?.statusDescriptions?.created;
		case 2:	return store.getState().global?.global_data?.statusDescriptions?.starting;
		case 3:	return store.getState().global?.global_data?.statusDescriptions?.available;
		case 4:	return store.getState().global?.global_data?.statusDescriptions?.waiting;
		case 5:	return store.getState().global?.global_data?.statusDescriptions?.completed;
		case 6:	return store.getState().global?.global_data?.statusDescriptions?.removed;
		default: return store.getState().global?.global_data?.statusDescriptions?.none;
	}
}

// REPORT_STATUS_NONE = 0
// REPORT_STATUS_CREATED = 1
// REPORT_STATUS_AVAILABLE = 2
// REPORT_STATUS_DEPRECATED = 3
// REPORT_STATUS_REMOVED = 4
export const getReportStatusDesc = (status) => {
	switch (parseInt(status)) {
		case 0: return store.getState().global?.global_data?.statusDescriptions?.none;
		case 1:	return store.getState().global?.global_data?.statusDescriptions?.created;
		case 2:	return store.getState().global?.global_data?.statusDescriptions?.available;
		case 3:	return store.getState().global?.global_data?.statusDescriptions?.deprecated;
		case 4:	return store.getState().global?.global_data?.statusDescriptions?.removed;
		default: return store.getState().global?.global_data?.statusDescriptions?.none;
	}
}
